import React, { useState } from "react";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Eye, ChevronDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

const labels = { admin: "Beheerder", planner: "Planner", volunteer: "Vrijwilliger" };

export function RoleSwitcher({ banner = false }) {
  const { user, switchRole } = useAuth();
  const [busy, setBusy] = useState(false);
  const active = user?.role !== user?.account_role;
  if (!user || (user.view_roles || []).length < 2 || (banner && !active)) return null;
  const choose = async (role) => {
    setBusy(true);
    try { await switchRole(role); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
  };
  if (banner) return <div className="flex flex-wrap items-center justify-between gap-2 bg-amber-100 text-amber-950 border-b border-amber-300 px-4 sm:px-6 py-3 text-sm" data-testid="role-view-banner">
    <span><strong>Bekijken als {labels[user.role]}</strong> · Je werkt met de rechten van deze rol, voor je eigen account.</span>
    <Button size="sm" variant="outline" disabled={busy} onClick={() => choose(user.account_role)} data-testid="role-view-restore">Terug naar {labels[user.account_role]}</Button>
  </div>;
  return <DropdownMenu>
    <DropdownMenuTrigger asChild><Button variant="outline" size="sm" className="shrink-0 px-2 sm:px-3" aria-label={`Bekijken als ${labels[user.role]}`} disabled={busy} data-testid="role-switcher-button">
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Eye className="w-4 h-4 mr-1" />}<span className="sm:hidden">Rol</span><span className="hidden sm:inline">Bekijken als {labels[user.role]}</span><ChevronDown className="w-3 h-3 ml-1" />
    </Button></DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="bg-white dark:bg-slate-900" data-testid="role-switcher-menu">
      {user.view_roles.map((role) => <DropdownMenuItem key={role} disabled={role === user.role} onClick={() => choose(role)} data-testid={`role-switch-${role}`}>{labels[role]}{role === user.account_role ? " (eigen rol)" : ""}</DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}
